module.exports = __webpack_public_path__ + "static/media/envelope_alarm_timeline.80bfcdbe.svg";